import React from "react";
import { connect } from "react-redux";
import { Col, Row } from "antd";
import styles from "./styles/SpecialSection.scss";
import SpecialAttributeCard from "./SpecialAttributeCard";
import SharingOptionsButton from "./SharingOptionsButton";
import FavoriteButton from "../../FavoriteButton";
import { Favorite } from "../../../components/Favorite";
import { HideAdButton } from "../../../components/HideAdButton";
import CarverticalWidget from "../../../components/CarverticalWidget";
import {
  specialAttributesInterface,
  summaryInterface
} from "../../../typings/interfaces";
import { selectLoadedUser } from "../../../routes/Auth/auth.ducks";
import { checkEmptyObject } from "../../../services";

interface SpecialSectionProps {
  ad?: { id: string; module: string, category: string  };
  adSummary?: summaryInterface;
  disabled?: boolean;
  specialAttributes?: specialAttributesInterface[];
  details?: any;
  user?: any;
}

const SpecialSection = ({
  specialAttributes,
  ad,
  disabled,
  adSummary,
  details,
  user
}: SpecialSectionProps) => {
  const isOwnAd = user && checkEmptyObject(user) && adSummary && user.userId === adSummary.creatorId;

  return (
  <section>
    {specialAttributes.length !== 0 ? (
      <div className={styles.container}>
        <div className={styles.topSpecialCard}>Karakteristike</div>
        <Row className={styles.row} gutter={27}>
          {specialAttributes.map((attribute: any) => (
            <Col key={attribute.field} xs={24} sm={12} md={specialAttributes.length > 3 ? 6 : 8}>
              <SpecialAttributeCard attribute={attribute} />
            </Col>
          ))}
        </Row>
      </div>
    ) : null}
    <CarverticalWidget
      module={ad && ad.module}
      category={ad && ad.category}
      details={details}
    />
    <div className={`${styles.buttonCard} ${isOwnAd ? styles.twoButtons : ''}`}>
      {/* Flag describes what exact button was clicked. "SpecialSection"
        represents the button in the ad details for that concrete ad. */}
      <FavoriteButton
        disabled={disabled}
        category={ad && ad.category}
        flag="SpecialSection"
        component={Favorite}
        ad={adSummary}
        adLists={{ detail: { data: [adSummary] } }}
      />

      {!isOwnAd && (
        <HideAdButton
          adSummary={adSummary}
        />
      )}

      <SharingOptionsButton disabled={disabled} category={ad && ad.category} />
    </div>
  </section>
  );
};

export default connect(
  (state: any) => ({
    user: selectLoadedUser(state)
  }),
  null
)(SpecialSection);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/SpecialSection.tsx